// extracted by mini-css-extract-plugin
module.exports = {"icon":"CompanyHeader_icon__7AiX1","companyName":"CompanyHeader_companyName__2UP0E","accountAddress":"CompanyHeader_accountAddress__1OLkV"};